module.exports = __webpack_public_path__ + "static/media/pay.beac86fe.png";